<template>
  <div class="line-chart">
    <GChart ref="gchart" type="LineChart" :data="chartData" :options="chartOptions" />
  </div>
</template>
<script>
import { GChart } from "vue-google-charts"
import helper from "@/helpers.js"
import { brandColors, generateColorPalette } from "@/lib/colorPalette.js"

export default {
  name: "ChatMessageLine",
  props: {
    message: {
      type: Object,
      required: true,
    },
  },
  components: {
    GChart
  },
  computed: {
    metaOptions() {
      try {
        console.log(this.message.display.meta)
        return JSON.parse(this.message.display.meta, this.options)
      } catch {
        return {}
      }
    },
    chartOptions() {
      const defaultOptions = {
        width: 800,
        height: 600,
        colors: this.chartColors
      }
      return Object.assign(this.metaOptions, defaultOptions)
    },
    chartColors() {
      return generateColorPalette(brandColors(), 2)
    },
    chartData() {
      const temp = []
      const data = this.message.data
      if (data.length > 0) {
        temp.push([helper.titleize(data[0][0].field_name), helper.titleize(data[0][1].field_name)])
        data.map((row) => {
          const t = []
          row.map((f) => t.push(f.value))

          return temp.push(t)
        })
      }
      console.debug("chartData", temp)
      return temp
    }
  },
  methods: {
    exportChartImage() {
      const g = this.$refs.gchart
      if (!g || !g.chartObject || typeof g.chartObject.getImageURI !== "function") {
        return null
      }
      try {
        return g.chartObject.getImageURI() || null
      } catch (e) {
        return null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.chart-container {
  width: 100% !important;
}
</style>